var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1255 16.0063L5.84065 20.9727L0.874308 5.68786L16.1591 0.721511L21.1255 16.0063Z",
    fill: "url(#pattern0_3594_1951)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3594_1951",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3594_1951",
    transform: "matrix(-0.0111111 0 0 -0.0111111 1 1)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3594_1951",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACwUlEQVR4nO3cz4tNYRzH8Wf8jCRWkjKlyE5ZyEoWioWaf0ApWSkb8R+QUcTCLFmyE8ozJVG2FqzYsFBjQkyx8/Otb51bEzNznnvmen6c5/Oq2Uz3ec5z3t2Ze865517nREREREREagWsAS4Bs8AccM1+l3pdvQNM8q+7ij360LMs7AGwdtTbq9YikQcUO1Joo9iRQhvFjhTaKHak0EaxI4U2ih0ptFHsSKGNYkcKbbxOauKENoodKbRR7EihjWJHCm0UO1Joo9iRQhvFjhTaKHak0EaxI4U2ih0ptFFs4vFVn65HDF13bOLzVcZOELrO2KTjq4qdMHRdsUnPVxGbPPjexyYfvtexyYvvbWzy43sZmzz53sUmX75Xscmb701s8nevFx/zoAxXXekow2dXOsow40pHGS660pG3d83nIPViuIQpYAewHdgc8LPK9Rn/zwdgXer9qyG0OZl6/7JBdw8DHvMSGEu9j1noGPlR860IjwMeezT1PmahQ+RnwIZm7ETA45+k3scsDBn5NbBl3tgVwJuAcftc7YaI/BHYtcD4MwFjb7naBUb+CuxdZPxG4EvL+B/AuKtZQOTvwOGWOa4HzHPF1awlzm/geMAcO4FfAX8Vm1ytWuKcHWIeezekzTlXq+bCzUKmhpznCO1menGBaITfEnbbDt2GnGcMeBUQ+5irUXOGN9k8sz/ZixawuuNcpwJCPx/9XlQGWG9vOwXEPpR6rcUDLgeEnk69zuIB48DPgNh7Uq+1eMCdgNA3U6+zeMDBgNDfgK2p11o84EVA7Aup11k84ERA6LnBtW3pyG5OBN4HxD7ddRvSAM4HhLY3DlYOxkgHwLbmMmubA13ml3ma6yZtdFvCcgH7A0JPLHtD4iz20yUi24UsHXmMArC7Cfo3+/+tZ/MoNTc73gDeNod993UbgoiIiIiIiGv3Bx1KMixaBUSUAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/Cursor.f21726d092b71a7abc3287bb42aa4228.svg";
export { ForwardRef as ReactComponent };